var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"succeed-box"},[_c('img',{attrs:{"src":require('../../assets/'+_vm.appTheme+'/succeed.png'),"alt":""}}),_c('div',{staticClass:"succeed-box-content"},[_c('div',{staticClass:"succeed-hint"},[_vm._v("恭喜您，支付成功")]),_c('div',{staticClass:"go-index",on:{"click":_vm.goIndex}},[_vm._v("返回商城")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }